import { toDateInput } from 'helpers/date';

export const defaultState = {
  level: '',
  domain: '',
  designation: '',
  validFrom: null,
  validTo: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      level: action.payload.level?.name,
      domain: action.payload.domain?.name,
      validFrom: action.payload.validFrom ? toDateInput(action.payload.validFrom) : undefined,
      validTo: action.payload.validTo ? toDateInput(action.payload.validTo) : undefined,
    };
  }
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
} 